export default "__VITE_PUBLIC_ASSET__df62336d__"